// @flow
import type { Action } from '../actions/listingCounts';

export type State = ?{ [string]: number };

export default function listingCounts(state: State = null, action: Action) {
  switch (action.type) {
    case 'LISTING_COUNTS_SET': {
      return action.counts;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
